export const postMessage = payload => window.parent.postMessage(JSON.stringify(payload), '*');

export const postContentLoaded = () => {
    const height = document.getElementById('root').scrollHeight;
    const payload = { eventType: 'contentLoaded', dataVersion: 'v1', data: { finalHeight: height } };
    postMessage(payload);
    console.log('posted content loaded', payload);
}

const _postContentResized = () => {
    let lastHeight = 0;
    const minHeight = 650;
    return (action) => {
        const height = document.getElementById('root').scrollHeight;
        if(lastHeight !== height){
                const payload = { eventType: 'contentResized', dataVersion: 'v1', data: { updatedHeight: height < minHeight ? minHeight : height } };
                postMessage(payload);
                lastHeight = height;
                console.log('content Resized posted', payload);
        }
    }
}

export const postContentResized = _postContentResized()

export const postReservationPlaced = ({ prereservationId }) => {
    const payload = { eventType: 'reservationPlaced', dataVersion: 'v1.1', data: { prereservationId: prereservationId.toString(), quantity: 1 } }
    postMessage(payload);
    console.log('reservation Placed', payload);
}

export const postReservationFailed = data => {
    const payload = { eventType: 'reservationFailed', dataVersion: 'v1', data }
    postMessage(payload);
    console.log('reservation Failed', payload);
}

export const postScrollToTop = () => {
    const payload = { eventType: 'scrollToTop', dataVersion: 'v2.1' }
    postMessage(payload);
    console.log('scrollToTop posted', payload);
}


// WEBPACK FOOTER //
// ./src/services/iframe.js